export const OG_TYPE_PRODUCT = 'product';
